<sub-header [isModal]="true" [windowHash]=windowHash></sub-header>
<p-scrollPanel [style]="{width: '100%', height: '85vh'}" styleClass="custombar1">
  <div class="container-fluid">
    <div class="row p-md">
      <div class=" col-12 " id="sc-print-section">
        <div class="col-12 text-right" *ngIf="this.printEnabled">
          <button (click)="this.print()" class="btn btn-sm btn-outline-primary print-btn"
            title="{{ 'General.printsection' | translate }}" type="button"><i class="fa fa-print"></i> {{
            'General.printsection' | translate }}</button>
        </div>
        <span #messageContainer></span>
      </div>
    </div>
  </div>
</p-scrollPanel>